enum InterestRepaymentType {
    InterestOnly = 1,
    CaptialAndInterest = 2,
}
export default InterestRepaymentType